<template>
  <YouTubeVideosTable/>
</template>

<script setup>
import YouTubeVideosTable from "./YouTubeVideosTable.vue";
</script>

<style scoped></style>
